<template>
	<div v-if="detail_info" class="ds_detail width_100">
		<div class="ds_swiper width_100">
			<van-swipe :autoplay="5000" @change="swiperChange" :show-indicators="false">
				<van-swipe-item v-for="(item_sw,index_sw) in detail_info.thumbList" :key="'sw'+index_sw">
					<van-image class="ds_swiper_item width_100" fit="cover" :src="item_sw" />
				</van-swipe-item>
			</van-swipe>
			<div class="ds_swiper_ind display_center_center">
				<div :class="[{'ds_swiper_ind_itemS':cur_swi_index==index_ind},'ds_swiper_ind_item']"
					v-for="(item_ind,index_ind) in detail_info.thumbList" :key="'ind'+index_ind"></div>
			</div>
		</div>
		<div class="ds_body width_100">
			<div class="ds_body_1 width_100 color_333333 font_size_36 font_weight_600">{{detail_info.serviceName}}</div>
			<!-- <div class="ds_body_2 width_100 color_999999 font_size_24">{{detail_info.facility_str}}</div> -->
			<div @click="openMap()" class="ds_body_3 width_100 bg_FFFFFF border_radius_16">
				<div class="ds_body_3_1 width_100 font_size_30 color_333333 text_ellipsis">
					{{detail_info.venueInfo.venueName}}
				</div>
				<div class="ds_body_3_2 width_100 font_size_30 color_333333 text_ellipsis">
					<div class="width_fit font_size_24 color_999999 text_ellipsis">
						{{detail_info.venueInfo.address}}
					</div>
				</div>
			</div>
			
			<div class="ds_body_5 width_100 bg_FFFFFF border_radius_16">
				<!--  -->
				<!-- <div v-if="detail_info.venueInfo.openTimeDesc" class="width_100 display_start_center font_size_26 color_333333 font_weight_600">
					营业时间
				</div>
				<div v-if="detail_info.venueInfo.openTimeDesc" class="ds_body_5_2 width_100 color_666666 font_size_24" v-html="detail_info.venueInfo.openTimeDesc"></div>
				<div v-if="detail_info.venueInfo.facilitiesList.parking" class="width_100 ds_body_5_3 display_start_center font_size_26 color_333333 font_weight_600">
					停车服务
				</div>
				<div v-if="detail_info.venueInfo.facilitiesList.parking" class="ds_body_5_2 width_100 color_666666 font_size_24" v-html="detail_info.venueInfo.facilitiesList.parking"></div>
				<div v-if="detail_info.venueInfo.facilitiesList.swimmingPool" class="width_100 ds_body_5_3 display_start_center font_size_26 color_333333 font_weight_600">
					泳池规格
				</div>
				<div v-if="detail_info.venueInfo.facilitiesList.swimmingPool" class="ds_body_5_2 width_100 color_666666 font_size_24" v-html="detail_info.venueInfo.facilitiesList.swimmingPool"></div> -->
				<!--  -->
				<div v-if="detail_info.venueInfo.openTimeDesc||detail_info.venueInfo.facilitiesList.parking||detail_info.venueInfo.facilitiesList.swimmingPool" class="width_100 display_start_center font_size_28 color_333333 font_weight_600">
					场馆详情
				</div>
				<div v-if="detail_info.venueInfo.openTimeDesc" class="ds_body_5_2 ds_body_5_4  ds_body_5_5 width_100 color_666666 font_size_26" v-html="detail_info.venueInfo.openTimeDesc"></div>
				<div v-if="detail_info.venueInfo.facilitiesList.swimmingPool" class="ds_body_5_2 ds_body_5_4 ds_body_5_6 width_100 color_666666 font_size_26" v-html="detail_info.venueInfo.facilitiesList.swimmingPool"></div>
				<div v-if="detail_info.venueInfo.facilitiesList.parking" class="ds_body_5_2 ds_body_5_4 ds_body_5_7 width_100 color_666666 font_size_26" v-html="detail_info.venueInfo.facilitiesList.parking"></div>
				
				<div v-if="detail_info.rules.bookingInstructions" class="width_100 ds_body_5_3 display_start_center font_size_28 color_333333 font_weight_600">
					预约须知
				</div>
				<div v-if="detail_info.rules.bookingInstructions" class="ds_body_5_2 width_100 color_666666 font_size_26" v-html="detail_info.rules.bookingInstructions"></div>
				<div v-if="detail_info.rules.cancellationPolicy" class="ds_body_5_3  width_100 display_start_center font_size_28 color_333333 font_weight_600">
					退订规则
				</div>
				<div v-if="detail_info.rules.cancellationPolicy" class="ds_body_5_2 width_100 color_666666 font_size_26" v-html="detail_info.rules.cancellationPolicy"></div>
				<div v-if="detail_info.venueInfo.tips" class="ds_body_5_3  width_100 display_start_center font_size_28 color_333333 font_weight_600">
					温馨提示
				</div>
				<div v-if="detail_info.venueInfo.tips" class="ds_body_5_2 width_100 color_666666 font_size_26" v-html="detail_info.venueInfo.tips"></div>
				<div v-if="detail_info.venueInfo.introduce" class="ds_body_5_3  width_100 display_start_center font_size_28 color_333333 font_weight_600">
					场馆介绍
				</div>
				<div v-if="detail_info.venueInfo.introduce" class="ds_body_5_2 width_100 color_666666 font_size_26" v-html="detail_info.venueInfo.introduce"></div>
			</div>
		</div>
	</div>
</template>
<script>
	import {
		datePrintStr
	} from "../lib/utils.js"
	import {
		getCitysFromTemplateV2,getVenuesFromTemplateV2V2,getVenueDetailFromTemplateV2V2
	} from '../api/api.js'
	export default {
		data() {
			return {
				cur_swi_index: 0, //当前轮播图索引
				detail_info:null
			}
		},
		mounted() {
			console.log(this.$route.params);
			this.$loading('正在加载中...');
			this.getVenusDetail()
		},
		methods: {
			async getVenusDetail(){
				// var $this = this
				// // console.log(this.$route);
				// var params=this.$route.params
				// try {
				// 	var res=await getVenueDetailFromTemplateV2(params)
				// 	console.log(res);
				// 	// res.data.businessTime='周一至周日 9:00 - 22:00周一至周日 9:00 - 22:00\n dsafsdfw4sesversv'
				// 	// res.data.facility_str=res.data.facility.join('，')
				// 	// $this.detail_info=res.data
				// 	// $this.getStockList()
				// } catch (error) {
				// 	//TODO handle the exception
				// 	$this.$loading.close();
				// }
				
				
				var $this = this
				var param = this.$route.params
				try {
					var res=await getVenueDetailFromTemplateV2V2(param)
					$this.detail_info=res.data
					if(res.data.noticeContent){
						$this.$dialog.alert({
						  title: '温馨提示',
						  message: res.data.noticeContent,
						  messageAlign:'left',
						  confirmButtonColor:'#F77F28'
						}).then(() => {
						  // on close
						});
					}
					
					$this.$loading.close();
				} catch (error) {
					//TODO handle the exception
				}
				return
				var qs = require('qs');
				let url = this.api.userApi.getVenueDetailFromTemplateV2
				this.axios.post(url, qs.stringify(param))
					.then((res) => {
						console.log(res);
						$this.detail_info=res.data
						if(res.data.noticeContent){
							$this.$dialog.alert({
							  title: '温馨提示',
							  message: res.data.noticeContent,
							  messageAlign:'left',
							  confirmButtonColor:'#F77F28'
							}).then(() => {
							  // on close
							});
						}
						
						$this.$loading.close();
					}).catch((error) => {
						$this.$loading.close();
						$this.$toast(error.data.msg?error.data.msg:error.msg);
					})
			},
			swiperChange(e) {
				this.cur_swi_index = e
			},
			getStockIndex(e){
				this.$RCLoading.show();
				this.sportTypeInfos_index=e
				this.getStockList()
			},
			async getStockList(){
				var $this = this
				// // console.log($this.detail_info.sportTypeInfos);
				// // console.log($this.sportTypeInfos_index);
				if(!$this.detail_info.sportTypes || !$this.detail_info.sportTypes[$this.sportTypeInfos_index] || !$this.detail_info.sportTypes[$this.sportTypeInfos_index].venueId){
					$this.is_load_stock_list=true
					$this.stock_list=[]
					$this.stock_info=null
					$this.$RCLoading.hide();
					return
				}
				var params={
					serviceId:$this.detail_info.sportTypes[$this.sportTypeInfos_index].serviceId,
					// sportType:$this.detail_info.sportTypes[$this.sportTypeInfos_index].sportType,
					projectKey:this.$route.params.projectKey
				}
				// // console.log(params);
				try {
					var res=await venueProduct(params)
					// console.log('venueProduct',res);
					if(res.data.siteNums&&res.data.siteNums.length>0){
						res.data.siteNums.map((item)=>{
							item.day_obj=datePrintStr(item.day)
						})
					}
					
					// // console.log('getStockList',res.data);
					$this.stock_list=res.data.siteNums
					$this.is_load_stock_list=true
					$this.stock_info=res.data
					$this.$RCLoading.hide();
				} catch (error) {
					//TODO handle the exception
					$this.$RCLoading.hide();
				}
			},
			selectStock(e){
				// console.log(e);
				var $this = this
				// console.log($this.detail_info);
				var param={
					serviceId:$this.detail_info.sportTypes[$this.sportTypeInfos_index].serviceId,
					sportType:e.sportType,
					bookDate:e.day,
					venueName:$this.detail_info.venueName,
					projectKey:this.$route.params.projectKey,
					venueId:this.$route.params.venueId,
				}
				sessionStorage.setItem('stock_list',JSON.stringify($this.stock_list))
				// console.log(param,$this.stock_list);
				// return
				// sessionStorage.setItem('detail_info',JSON.stringify($this.detail_info))
				setTimeout(()=>{
					$this.$router.push({
						name:'rcb_timetable',
						params:param
					})
				},30)
								
				
			},
			openMap(){
				console.log(this.detail_info);
				// return
				var lat=this.detail_info.venueInfo.latitude
				var lng=this.detail_info.venueInfo.longitude
				var encodeName=encodeURIComponent(this.detail_info.venueInfo.venueName)
				var encodeAddr=encodeURIComponent(this.detail_info.venueInfo.address)
				
				var url=`https://uri.amap.com/marker?position=${lng},${lat}&name=${encodeName}&showInfo=0&coordinate=gaode&callnative=0&hideNav=1&zoom=17&hideRoute=1&hideControl=1&navi=0&hideInfo=1`
				
				window.location.href=url
			},
		}
	}
</script>

<style lang="less" scoped="scoped">
	@vm_base: 1/750*100vw;
	.ds_detail {
		min-height: 100vh;
		background-color: #F6F7F9;
	}
	.ds_swiper {
		position: relative;
	
		.ds_swiper_item {
			height: 580*@vm_base;
		}
	
		.ds_swiper_ind {
			position: absolute;
			bottom: 60*@vm_base;
			right: 30*@vm_base;
	
			.ds_swiper_ind_item {
				width: 10*@vm_base;
				height: 10*@vm_base;
				background: rgba(255, 255, 255, 0.4);
				border-radius: 50%;
				margin: 0 3*@vm_base;
			}
	
			.ds_swiper_ind_itemS {
				background: rgba(255, 255, 255, 1);
			}
		}
	}
	.ds_body{
		position: relative;
		margin-top: -30*@vm_base;
		background-color: #F6F7F9;
		border-radius: 16*@vm_base 16*@vm_base 0 0;
		padding: 30*@vm_base;
		padding-bottom: calc(constant(safe-area-inset-bottom) / 2 + 30*@vm_base);
		padding-bottom: calc(env(safe-area-inset-bottom) / 2 + 30*@vm_base);
	}
	.ds_body_1{
		line-height: 1.2;
		padding: 0 20*@vm_base;
	}
	.ds_body_2{
		margin-top: 20*@vm_base;
	}
	.ds_body_3{
		margin-top: 20*@vm_base;
		padding:30*@vm_base;
		.ds_body_3_1{
			padding: 0 0 0 50*@vm_base;
			line-height: calc(40 / 30);
			background-image: url(../resource/location.png);
			background-repeat: no-repeat;
			background-size: auto 100%;
			background-position: left center;
		}
		.ds_body_3_2{
			padding: 0 0 0 50*@vm_base;
			margin-top: 10*@vm_base;
			div{
				max-width: 100%;
				padding-right: 50*@vm_base;
				line-height: calc(34 / 24);
				background-image: url(../resource/fly.png);
				background-repeat: no-repeat;
				background-position: right center;
				background-size: auto 32*@vm_base;
			}
		}
	}
	
	.ds_body_5{
		margin-top: 20*@vm_base;
		padding:30*@vm_base;
		.ds_body_5_2{
			margin-top: 10*@vm_base;
			line-height: calc(46 / 24);
			white-space: pre-line;
		}
		.ds_body_5_3{
			margin-top: 20*@vm_base;
		}
		.ds_body_5_4{
			padding-left: 130*@vm_base;
		}
		.ds_body_5_5{
			position: relative;
			&::after{
				content: '营业时间：';
				position: absolute;
				left: 0;
				top: 0;
			}
		}
		.ds_body_5_6{
			position: relative;
			&::after{
				content: '泳池详情：';
				position: absolute;
				left: 0;
				top: 0;
			}
		}
		.ds_body_5_7{
			position: relative;
			&::after{
				content: '停车服务：';
				position: absolute;
				left: 0;
				top: 0;
			}
		}
		/*
		
		泳池详情：
		：
		*/
	}
</style>


// WEBPACK FOOTER //
// src/views/main_detail.vue